export default __webpack_public_path__ + "static/media/mauquenchy5.374e3b85.jpg";